import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../ui/button/button';
import Lottie from '../../../common/lottie';
import { BUTTON_VARIANTS } from '../../../constants/button-variants';
import ROUTES from '../../../constants/routes';
import translation from '../../../languages';
import './no-results.scss';

const NoResults: FC<RouterWithTranslation> = ({ t }) => {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(ROUTES.SEARCH_RESULT.path);
    };

    return (
        <div className='container no-results text-center'>
            <div className='d-flex align-items-center justify-content-center'>
                <div className='lottie-wrapper'>
                    <Lottie id='bf87afdc-a146-46ab-b1b0-e4aa22598145/ZCaJ2p0rtQ' />
                </div>
            </div>
            <div className='tsc-h2 mb-4'>{t('cart.noResults.title')}</div>
            <div className='tsc-h4'>{t('cart.noResults.subtitle')}</div>
            <div className='tsc-h4 mb-5'>{t('cart.noResults.subtitle2')}</div>
            <div>
                <Button className='block-center' variant={BUTTON_VARIANTS.YELLOW} onClick={handleClick}>
                    {t('cart.noResults.buttonText')}
                </Button>
            </div>
        </div>
    );
};

const translate = translation('cart');

export default translate(NoResults);
